import { Achievement } from '../types';

export const achievements: Achievement[] = [
  {
    number: "20+",
    label: "Published Apps",
    icon: "Smartphone",
  },
  {
    number: "5+",
    label: "Years Experience",
    icon: "Calendar",
  },
  {
    number: "99.5%",
    label: "Crash-free Rate",
    icon: "Award",
  },
  {
    number: "100K+",
    label: "Users Served",
    icon: "Users",
  },
];